import { iterLines, tokens } from './lexer.js';
export function parseAtM00(content) {
    const file = { entries: [], unparsed: [] };
    for (const line of iterLines(content)) {
        const body = line.trimmed.trim();
        if (body === '')
            continue;
        if (body.startsWith(';') || body.startsWith('//'))
            continue;
        const parts = tokens(body);
        if (parts.length < 2) {
            file.unparsed.push({ lineNo: line.lineNo, raw: line.raw, reason: 'too few tokens' });
            continue;
        }
        const [head, ...rest] = parts;
        if (head === 'DATUM') {
            file.date = rest.join(' ');
            continue;
        }
        if (head === 'DATEINAME') {
            file.filename = rest.join(' ');
            continue;
        }
        if (head.length !== 1) {
            file.unparsed.push({
                lineNo: line.lineNo,
                raw: line.raw,
                reason: `expected 1-char category, got '${head}'`,
            });
            continue;
        }
        file.entries.push({ category: head, code: rest.join(' ') });
    }
    return file;
}
//# sourceMappingURL=at-m00.js.map